export const PopoverStyles = {
	baseStyle: {
		popper: {
			zIndex: 100,
		},
	},
};
